import { useUpdateEntity } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import { EntityInterface } from 'common/types/entities/EntityInterface'
import { DiscriminatorItem, usePreserveFieldsAcrossDiscriminator } from '.'

export const usePreserveEntityFieldsAcrossDiscriminator = <
  Entity extends EntityInterface,
  PreservedKeys extends keyof Entity,
  DiscriminatorValues extends DiscriminatorItem<Entity, keyof Entity>[],
>({
  entity,
  discriminator,
  preservedKeys,
}: {
  entity: Entity
  discriminator: DiscriminatorValues
  preservedKeys: PreservedKeys[]
}) => {
  const updateEntity = useUpdateEntity<Entity>()
  return usePreserveFieldsAcrossDiscriminator({
    object: entity,
    discriminator,
    preservedKeys,
    updateObject: updateEntity,
  })
}
